export default function AvatarPreview () {
  $(function () {
    $('.img-avatar, .upload-btn').click(function (e) {
      $('#user_avatar').click();
    });
  });
  $('#user_avatar').on('change', function (e) {
    if (this.files && this.files[0]) {
      var reader = new window.FileReader();
    }
    reader.onload = function (e) {
      $('#avatar_upload, .img-avatar').attr('src', e.target.result);
    }

    reader.readAsDataURL(this.files[0]);
  });
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/users/avatar_preview.js